<template>
<div>
  
  <page-padding>
        <div v-if="!hasTalks">{{$t('language.no_teacher_talks')}}</div>
  </page-padding>    
       
       <!-- dont need an infinite list here... -->
      
        <button-talk v-for='(item,index) in teacher_talks[group_id+"talks"]' :item="item" :key="index"></button-talk>
       
</div>
</template>

<script>

import ButtonTalk from '../talks/ButtonTalk.vue';
import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding.vue';
import { eventBus } from '../../services/EventBus';

export default {
  name: 'list-talks',
  props:{
    group_id:{default:0}
  },
  data(){
    return {
    }
  },
  computed:{
     ...mapState([
       'teacher_talks'
       ]),
       hasTalks:function(){
         if(this.teacher_talks[this.group_id+"talks"]){
           return this.teacher_talks[this.group_id+"talks"] ? this.teacher_talks[this.group_id+"talks"].length : false
         }else{
           return false;
         }
       }
  },
  components:{
    ButtonTalk,
    PagePadding
  },
  methods:{
    emitLoadStart(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_START_LOAD')
        vm=vm.$parent;
      }
    },
    emitLoadEnd(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_END_LOAD')
        vm=vm.$parent;
      }
    },
    loadTeacherTalks(){
      
      this.emitLoadStart();
       this.$store.dispatch('get_teacher_talks',{store_key:this.group_id+"talks",group_id:0,talk_id:0}).then(()=>{
         this.emitLoadEnd();
       })
    },
  },
  mounted:function(){
    eventBus.$on("RELOAD_FROM_PULL",this.loadTeacherTalks)
    this.loadTeacherTalks();
  },
  beforeDestroy(){
   eventBus.$off("RELOAD_FROM_PULL",this.loadTeacherTalks)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.talk-button{
  text-align:center;
  border:1px solid grey;
  display: inline-block;
  flex:1;
  padding:10px 5px;
  cursor:pointer;
  margin:2px;
}

</style>
